import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { MOVIE } from '../../../constants/itemTypes.js'
import getData from '../../../functions/getData.js'
import { CLI_CINEMA_CLIENT_ID, CLI_MULTICINEMA_MODE, FEATURES, PRINT_TYPES_DATA, PRINT_WEEKS, PROGRAM_ATTRIBUTES, PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_PERFORMANCES, UI_PROGRAM } from '../../../constants/state.js'
import { A4, A3, A1, SHOWCASEREDUCED } from '../../../constants/printType.jsx'
import toJS from '../../../hoc/toJS.jsx'
import EditPrintTypes from '../present/EditPrintType.jsx'
import printConfig from '../../../print-config.json'
import getPrintAllFormatsSubKey from '../../../functions/getPrintAllFormatsSubKey.js'
import { onPrintTypesPdfRequest, onPrintTypesPdfResetState, printToolAddItem, printToolDeleteItem, printToolReorderItem, printToolSetWeek } from '../../../actions/index.js'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple.jsx'
import filterMoviesByWeekAndCinema from '../../../functions/cinemaAndTimeRangeFilters/filterMoviesByWeekAndCinema.js'
import filterItemsByOrder from '../../../functions/cinemaAndTimeRangeFilters/filterItemsByOrder.js'
import filterAttributesByCinema from '../../../functions/cinemaAndTimeRangeFilters/filterAttributesByCinema.js'
import getOptionalCinemaId from '../../../functions/cinemaAndTimeRangeFilters/getOptionalCinemaId.js'
import findWeekObWithIsoWeek from '../../../functions/findWeekObWithIsoWeek.js'


const movieFilterConfig = [
    {
        id: 'genres',
        transId: 'movie_edit_movie_genres'
    },
    {
        id: 'technical',
        transId: 'section_filter_select_film_series_title_display'
    },
    {
        id: 'fsk',
        transId: 'movie_attributes_fsk'
    },
    {
        id: 'period',
        transId: 'section_filter_select_period_display_title'
    },
]


const dragListConfig = [
    {
        titleTransId: 'section_filter_current_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'currentMovies',
        canEdit: true,
        hasAddNewItem: false,
        hasRemoveItem: false,
        
    },
    {
        titleTransId: 'print_upcoming_movies',
        buttonTextTransId: null,
        type: MOVIE,
        dataType: 'futureMovies',
        canEdit: true,
        hasAddNewItem: false,
        hasRemoveItem: false
    }
]



const PageFormatNotFound = ({pageName}) => (
    <WrapperPageSimple pageTitle={pageName}>
        <div className="site-content">Format nicht verfügbar.</div>
    </WrapperPageSimple>
)



const mapStateToProps = (state, ownProps) => ({
    // currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    currentClientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    selectedItems:  getData(state, [PRINT_TYPES_DATA, ownProps.params.printType, 'allFormats', getPrintAllFormatsSubKey(ownProps.params.printFormat, ownProps.params.landscape), 'items']),
    moviesItems:    getData(state, [PROGRAM_CLI_MOVIES_ITEMS]),
    moviesOrder:    getData(state, [PROGRAM_CLI_MOVIES_ORDER]),
    performances:   getData(state, PROGRAM_PERFORMANCES),
    attributes:     getData(state, PROGRAM_ATTRIBUTES),
    status:         getData(state, [PRINT_TYPES_DATA, 'status']),
    errorMsg:       getData(state, [PRINT_TYPES_DATA, 'error']),
    displayDropzones: getData(state, [UI_PROGRAM, 'activeDropzones']),
    weeks:          getData(state, PRINT_WEEKS),
    dataActiveWeek: getData(state, [PRINT_TYPES_DATA, 'currentWeek']),
    features:       getData(state, FEATURES)
})


const mapDispatchToProps = (dispatch, ownProps) => ({

    onSetWeek: (week) => {
        dispatch(printToolSetWeek(week))
  },

    onAddItem: (listId, itemId, itemType) => {
        dispatch(printToolAddItem(ownProps.params.printType, ownProps.params.printFormat, ownProps.params.landscape, itemId))
    },

    onReorderItem: (dragIndex, hoverIndex) => {
        dispatch(printToolReorderItem(ownProps.params.printType, ownProps.params.printFormat, ownProps.params.landscape, dragIndex, hoverIndex))
    }, 

    onDeleteItem: (itemId) => {
        dispatch(printToolDeleteItem(ownProps.params.printType, ownProps.params.printFormat, ownProps.params.landscape, itemId))
    },

    onPdfRequest: () => {
        const allFormatsSubKey = getPrintAllFormatsSubKey(ownProps.params.printFormat, ownProps.params.landscape)

        dispatch(onPrintTypesPdfRequest(allFormatsSubKey, ownProps.params.printFormat, ownProps.params.landscape, ownProps.params.week, ownProps.params.printType, ownProps.params.cinemaId))
    },

    onPdfReset: ()  => {
        dispatch(onPrintTypesPdfResetState())
    }
})

class EditPrintTypeContainer extends Component {
    constructor(props) {
        super(props)
    }

    componentDidUpdate() {
        const { dataActiveWeek, params, onSetWeek } = this.props
        const week = parseInt(params.week)

        if(dataActiveWeek != week) {
            onSetWeek(week)
        }
    }

    getItemsData() {
        const { moviesOrder, moviesItems, selectedItems, performances, attributes, currentClientCinemaId, multicinemaMode, weeks, params } = this.props 
        const { cinemaId, week } = params

        const weekObj = findWeekObWithIsoWeek(weeks, parseInt(week))
        const optionalCinemaId = getOptionalCinemaId(multicinemaMode, cinemaId, currentClientCinemaId)
        const relevantMovies = filterMoviesByWeekAndCinema(moviesOrder, moviesItems, performances, weekObj, cinemaId)

        return {
            moviesOrder: relevantMovies.relevant,
            moviesItems: filterItemsByOrder(relevantMovies.relevant, moviesItems),
            currentMovies: relevantMovies.current,
            futureMovies: relevantMovies.future,
            selectedItems: selectedItems,
            attributes: filterAttributesByCinema(attributes, optionalCinemaId)
        }
    }

    itemsDataCallback(dataType, itemsData) {
        return {
            items: itemsData.moviesItems,
            order: itemsData[dataType], ////?????
            selected: itemsData.selectedItems
        }
    }

    render() {
        const { params, basicUrl, status, errorMsg, displayDropzones, closePagePath, onAddItem, onReorderItem, onDeleteItem, onPdfRequest, features, onPdfReset} = this.props
        const { printType, printFormat, landscape } = params
        const itemsData = this.getItemsData()

        if(!itemsData) {
            return ''
        }
        
        const disableButton = 0 === itemsData.selectedItems.length 
        const allFormatsSubKey = getPrintAllFormatsSubKey(printFormat, landscape)
        
        
        if(landscape !== "true" && landscape !== "false"  || !allFormatsSubKey) {
            return <PageFormatNotFound pageName='' />
        }
        
        const formatConfig = printConfig.formats[allFormatsSubKey]
    
        if(formatConfig.path !== A4 && formatConfig.path !== A3 && formatConfig.path !== A1 && formatConfig.path !== SHOWCASEREDUCED) {
            return <PageFormatNotFound pageName='' />
        }
    
        const printTypeNameTransId = printConfig.routes[printType].transIdname
        const printFormatNameTransId = formatConfig.transId
    
    
        return <EditPrintTypes
            printTypeNameTransId={printTypeNameTransId}
            printFormatNameTransId={printFormatNameTransId}
            status={status}
            errorMsg={errorMsg}
            closePagePath={closePagePath}
            basicUrl={basicUrl}
            features={features}
            printType={printType}
    
            dragListConfig={dragListConfig}
            movieFilterConfig={movieFilterConfig}
            itemsData={itemsData}
            itemsDataCallback={this.itemsDataCallback}
    
            displayDropzones={displayDropzones}
            disableButton={disableButton}
    
            onAddItem={onAddItem}
            onReorderItem={onReorderItem}
            onDeleteItem={onDeleteItem}
            onPdfRequest={onPdfRequest}
            onPdfReset={onPdfReset}
        />
    }
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditPrintTypeContainer)